import React from 'react';
import DropZone from './drop-zone/DropZone';

export const UploadForm = ({ type, level, dropZoneDescription, onLoad }) => {
    return (
        <section className="editElement">
            <h1>
                Upload - {type}: {level} Level
            </h1>
            <DropZone onLoad={onLoad} dropZoneDescription={dropZoneDescription} />
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/UploadForm.js